import React from "react";
import { toast } from "react-toastify";
import { TYPE_TOAST } from "../../../base/constants/default";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(() => {
    return {
        title: {
            fontWeight: 700
        },
        content: {}
    };
});
const CloseToast = () => {
    return (React.createElement("svg", { style: { alignSelf: 'center' }, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M17 7L7 17", stroke: "#73777A", strokeWidth: "2.5", strokeLinecap: "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M7 7L17 17", stroke: "#73777A", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
const IconToast = ({ type = TYPE_TOAST.INFO }) => {
    switch (type) {
        case TYPE_TOAST.ERROR:
            return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M15.6105 8.38947L8.38947 15.6105M8.38947 8.38947L15.6105 15.6105M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "#EE0033", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
        case TYPE_TOAST.WARNING:
            return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M10.29 3.86001L1.82002 18C1.64539 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5468 2.53773 20.7239C2.83871 20.901 3.18082 20.9962 3.53002 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5468 22.0127 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.4471 18.6453 22.3547 18.3024 22.18 18L13.71 3.86001C13.5318 3.56611 13.2807 3.32313 12.9812 3.15449C12.6817 2.98585 12.3438 2.89726 12 2.89726C11.6563 2.89726 11.3184 2.98585 11.0188 3.15449C10.7193 3.32313 10.4683 3.56611 10.29 3.86001V3.86001Z", stroke: "#E9412B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M12 9V13", stroke: "#E9412B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M12 16V16.5", stroke: "#E9412B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
        case TYPE_TOAST.SUCCESS:
            return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999", stroke: "#006339", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M22 4L12 14.01L9 11.01", stroke: "#006339", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
        default:
            return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M11.5 16V11.3684M11.5 8H11.51M21.5 12C21.5 17.5228 17.0228 22 11.5 22C5.97715 22 1.5 17.5228 1.5 12C1.5 6.47715 5.97715 2 11.5 2C17.0228 2 21.5 6.47715 21.5 12Z", stroke: "#0054D1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
};
const ToastContent = ({ title, content }) => {
    const { cx, classes } = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: cx(classes.title) }, title),
        " ",
        React.createElement("br", null),
        React.createElement("span", { className: cx(classes.content) }, content)));
};
export const toastSuccess = ({ title, content, options }) => {
    return (toast.success(React.createElement(ToastContent, { title: title, content: content }), {
        ...options,
        icon: React.createElement(IconToast, { type: TYPE_TOAST.SUCCESS }),
        closeButton: React.createElement(CloseToast, null)
    }));
};
export const toastInfo = ({ title, content, options }) => {
    return (toast.info(React.createElement(ToastContent, { title: title, content: content }), {
        ...options,
        icon: React.createElement(IconToast, { type: TYPE_TOAST.INFO })
    }));
};
export const toastWarning = ({ title, content, options }) => {
    return (toast.warning(React.createElement(ToastContent, { title: title, content: content }), {
        ...options,
        icon: React.createElement(IconToast, { type: TYPE_TOAST.WARNING })
    }));
};
export const toastError = ({ title, content, options }) => {
    return (toast.error(React.createElement(ToastContent, { title: title, content: content }), {
        ...options,
        icon: React.createElement(IconToast, { type: TYPE_TOAST.ERROR })
    }));
};
